import React from 'react'

// theme
import aampeTheme from '../../constants/aampeTheme'

// hooks
import useSupportEmailMutation from '../../hooks/support/useSupportEmailMutation'

import BasicButton from '../buttons/basicButton'
import ErrorAlert from '../errors/ErrorAlert'
import BasicTextArea from '../inputs/basicTextArea'
import BasicModal from './basicModal'
// components
import ModalManager from './modalManager'

export default function SupportModal({ isOpen = false, handleClose }) {
    const mutation = useSupportEmailMutation()
    const [text, setText] = React.useState('')
    const submitRequest = () => {
        mutation.mutate({ support_request: text })
    }
    const closeModal = () => {
        setText('')
        handleClose()
        mutation.reset()
    }

    const cancelModal = () => {
        handleClose()
        mutation.reset()
    }

    return (
        <ModalManager isOpen={isOpen}>
            <BasicModal
                header={
                    mutation.isSuccess
                        ? 'Your Request Was Sent!'
                        : 'Support Request'
                }
                width="500px"
            >
                {mutation.isSuccess ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexFlow: 'column',
                        }}
                    >
                        <p style={{ margin: aampeTheme.spacing4(4) }}>
                            We will respond within 3 business days.
                        </p>
                        <div
                            style={{
                                display: 'flex',
                                margin: aampeTheme.spacing4(4, 0),
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <BasicButton
                                name="Close"
                                isPrimary={true}
                                action={closeModal}
                            />
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexFlow: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}
                    >
                        <div
                            style={{
                                marginBottom: aampeTheme.spacing4(4),
                                width: 'fit-content',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                flexFlow: 'column',
                            }}
                        >
                            {mutation.isError && (
                                <ErrorAlert title={mutation.error.message} />
                            )}

                            <BasicTextArea
                                label="How can we help?"
                                type="text"
                                placeholder="I'm having trouble with..."
                                value={text}
                                setValue={setText}
                                wrapperStyle={{
                                    margin: aampeTheme.spacing4(2, 0),
                                }}
                            />
                        </div>
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                            }}
                        >
                            <BasicButton
                                name="Cancel"
                                isPrimary={false}
                                action={cancelModal}
                                style={{ marginRight: aampeTheme.spacing4(2) }}
                                disabled={
                                    mutation.isLoading || mutation.isSuccess
                                }
                            />
                            <BasicButton
                                name="Submit"
                                isPrimary={true}
                                action={submitRequest}
                                isLoading={mutation.isLoading}
                                isSuccess={mutation.isSuccess}
                                isDisabled={!text.length}
                            />
                        </div>
                    </div>
                )}
            </BasicModal>
        </ModalManager>
    )
}
